import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { StorySection } from './components/StorySection';
import { ProgressionSection } from './components/ProgressionSection';
import { RiskAssessment } from './components/RiskAssessment';
import { TreatmentComparison } from './components/TreatmentComparison';
import { Discovery } from './components/Discovery';
import { ProductSection } from './components/ProductSection';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { PricingSection } from './components/PricingSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col w-full min-h-full bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main className="w-full" data-id="element-2">
        <Hero data-id="element-3" />
        <StorySection data-id="element-4" />
        <ProgressionSection data-id="element-5" />
        <RiskAssessment data-id="element-6" />
        <TreatmentComparison data-id="element-7" />
        <Discovery data-id="element-8" />
        <ProductSection data-id="element-9" />
        <Testimonials data-id="element-10" />
        <FAQ data-id="element-11" />
        <PricingSection data-id="element-12" />
        <CTASection data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}